import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'okaycanceldialog',
  templateUrl: './okaycanceldialog.component.html',
  styleUrls: ['./okaycanceldialog.component.scss']
})
export class OkayCanceldialogComponent implements OnInit, OnChanges {


  @Input() buttonTrigger: boolean;
  okayCancelDialogVisible: boolean;
  @Input() eventkey: string;
  @Input() message: string;
  @Output() ProcessresultFromdialog: EventEmitter<returnClick> = new EventEmitter();
  clickEvent: returnClick;
  constructor() {
    this.clickEvent = new returnClick();    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['buttonTrigger'] && changes['buttonTrigger']?.previousValue != changes['buttonTrigger']?.currentValue) {
      this.okayCancelDialogVisible = changes['buttonTrigger']?.currentValue;
    }
    this.clickEvent.eventkey = this.eventkey;
  }

  ngOnInit(): void {
  }

  OnOkayClicked() {
    this.clickEvent.isOkayClicked = true;
    this.ProcessresultFromdialog.emit(this.clickEvent);
  }

  OnCancelClicked() {
    this.clickEvent.isOkayClicked = false;
    this.ProcessresultFromdialog.emit(this.clickEvent);
  }

}

export class returnClick {
  isOkayClicked: boolean;
  eventkey: string;
}
